import { render, staticRenderFns } from "./SelectFiles.vue?vue&type=template&id=1351c16d"
import script from "./SelectFiles.vue?vue&type=script&lang=js"
export * from "./SelectFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports